import { Button } from 'primereact/button'
import React, { memo } from 'react'

// Define DocumentStyle type
export interface DocumentStyle {
  type: 'predefined' | 'custom' | null
  value:
    | 'formal-corporate'
    | 'formal-scientific'
    | 'entertaining'
    | 'persuasive'
    | 'instructional'
    | 'narrative'
    | 'conversational'
    | 'analytical'
    | 'regulatory'
    | 'visual'
    | 'inspirational'
    | 'custom'
    | null
  customValue?: string
}

interface DocumentStyleSelectorProps {
  documentStyle: DocumentStyle
  onStyleChange: (newStyle: DocumentStyle) => void
  disabled?: boolean
}

const DocumentStyleSelector: React.FC<DocumentStyleSelectorProps> = ({
  documentStyle,
  onStyleChange,
  disabled = false,
}) => {
  const handleStyleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value
    if (value === 'custom') {
      const newStyle: DocumentStyle = {
        type: 'custom',
        value: 'custom',
        customValue: '',
      }
      onStyleChange(newStyle)
    } else if (value === '') {
      const newStyle: DocumentStyle = {
        type: null,
        value: null,
      }
      onStyleChange(newStyle)
    } else {
      const newStyle: DocumentStyle = {
        type: 'predefined',
        value: value as DocumentStyle['value'],
      }
      onStyleChange(newStyle)
    }
  }

  const handleCustomStyleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newStyle: DocumentStyle = {
      type: 'custom',
      value: 'custom',
      customValue: e.target.value,
    }
    onStyleChange(newStyle)
  }

  return (
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      <select
        value={documentStyle.value || ''}
        onChange={handleStyleChange}
        className="nodrag"
        disabled={disabled}
        style={{
          padding: '4px 8px',
          borderRadius: '4px',
          border: '1px solid #ccc',
        }}
      >
        <option value="">No style</option>
        <option value="formal-corporate">Formal and Corporate</option>
        <option value="formal-scientific">Formal and Scientific</option>
        <option value="entertaining">Entertaining</option>
        <option value="persuasive">Persuasive</option>
        <option value="instructional">Instructional</option>
        <option value="narrative">Narrative</option>
        <option value="conversational">Conversational</option>
        <option value="analytical">Analytical</option>
        <option value="regulatory">Regulatory</option>
        <option value="visual">Visual</option>
        <option value="inspirational">Inspirational</option>
        <option value="custom">Custom style...</option>
      </select>
      {documentStyle.type === 'custom' && (
        <input
          type="text"
          value={documentStyle.customValue || ''}
          onChange={handleCustomStyleChange}
          placeholder="Enter custom style..."
          className="nodrag"
          disabled={disabled}
          style={{
            padding: '4px 8px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            width: '200px',
          }}
        />
      )}
    </div>
  )
}

export default memo(DocumentStyleSelector)
